module.exports = __webpack_public_path__ + "static/media/31.9f002696.webp";